import React from "react"
import Drawer from "@material-ui/core/Drawer"
import { withStyles } from "@material-ui/core/styles"
import classNames from "classnames"

const drawerWidth = "65%"

const styles = (theme) => ({
  drawerPaper: {
    whiteSpace: "nowrap",
    width: drawerWidth,
    background: "transparent",
    maxWidth: 330,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing.unit * 9,
    },
  },
  modal: {
    background: "#000",
    opacity: "0.84!important",
  },
})

class DrawerComp extends React.Component {
  render() {
    // console.log("DrawerComp -->>",this.props)
    const { open = false, children, classes, ...rest } = this.props
    return (
      <Drawer
        open={open}
        classes={{
          paper: classNames(
            classes.drawerPaper,
            !open && classes.drawerPaperClose
          ),
        }}
        onClose={this.props.onChange}
        {...rest}
        ModalProps={{
          classes: {
            root: classes.modal,
          },
        }}
      >
        {children}
      </Drawer>
    )
  }
}

export default withStyles(styles)(DrawerComp)



// WEBPACK FOOTER //
// ./src/components/Drawer.js